import { Alert, AlertColor, Snackbar } from "@mui/material";
import React, { ReactNode } from "react";

export const SnackBarContext = React.createContext<{toast(text: string, severity: AlertColor): void}>(null);


export const SnackbarProvider = (props: {children: ReactNode}) => {
  const [text, setText] = React.useState<string>(null); 
  const [severity, setSeverity] = React.useState<AlertColor>(null);
  const [open, setOpen] = React.useState<boolean>(false);


  const openSnackbar = React.useCallback((text: string, severity: AlertColor) => {
    setText(text);
    setSeverity(severity);
    setOpen(true);
  }, [open]);

  return (
    <SnackBarContext.Provider value={{toast: openSnackbar}}>
      <Snackbar 
        open             = {open}
        autoHideDuration = {3000}
        onClose          = {() => setOpen(false)}
        anchorOrigin     = {{ vertical: 'top', horizontal: 'center'}}
      >
        <Alert onClose={() => setOpen(false)} severity={severity} sx={{ width: '100%' }}>
          {text}
        </Alert>
      </Snackbar>
      {props.children}
    </SnackBarContext.Provider>
  ); 
}